//@ts-check
import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

/**
 * @module FetchHooks
 */
/**
 * @module PurchaseOrders
 */
/**
 *
 * @param {Object} props
 * @param {string} props.serie
 * @param {number} props.numero
 * @param {string} props.orgCompras
 * @param {string} props.fechaPedidoDesde
 * @param {string} props.fechaPedidoHasta
 * @param {string} props.ordenarPor
 * @param {number} props.page
 * @param {number} props.page_size
 */

const useFetchPurchaseOrders = ({
  serie,
  numero,
  orgCompras,
  fechaPedidoDesde,
  fechaPedidoHasta,
  ordenarPor,
  page,
  page_size,
}) => {
  const [response, setResponse] = useState()
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)
  const [numeroRegistros, setNumeroRegistros] = useState(0)

  const fetchData = useCallback(() => {
    setLoading(true)

    axios
      .post(
        `/efactura/purchaseorder/get_purchase_orders?page=${page}&page_size=${page_size ?? 12}`,
        {
          serie: serie,
          numero: numero,
          org_compras: orgCompras,
          fecha_pedido_desde: fechaPedidoDesde,
          fecha_pedido_hasta: fechaPedidoHasta,
          ordenar_por: ordenarPor,
        },
      )
      .then((request_response) => {
        if (request_response.data?.results) {
          setResponse(request_response.data.results)
          setNumeroRegistros(request_response.data.count)
        } else {
          setResponse(request_response.data)
          setNumeroRegistros(request_response.data.length)
        }

        setError(null)
      })
      .catch((request_error) => setError(request_error))
      .finally(() => setLoading(false))
  }, [serie, numero, orgCompras, fechaPedidoDesde, fechaPedidoHasta, ordenarPor, page, page_size])

  useEffect(() => {
    if (!loading) {
      fetchData()
    }
  }, [serie, numero, orgCompras, fechaPedidoDesde, fechaPedidoHasta, ordenarPor, page, page_size])

  return { response, error, loading, numeroRegistros }
}

export default useFetchPurchaseOrders
